import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) { toast.success("Welcome back to the glow"); navigate("/"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md p-8 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--card))]">
        <div className="text-center mb-6">
          <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-2">Welcome back</div>
          <h1 className="font-serif text-3xl">Sign in to Candle Co.</h1>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <Field label="Email" type="email" v={email} onC={setEmail} tid="login-email" />
          <Field label="Password" type="password" v={password} onC={setPassword} tid="login-password" />
          <Button data-testid="login-submit" disabled={loading} type="submit" size="lg" className="w-full rounded-full">
            {loading ? "Signing in…" : "Sign In"}
          </Button>
        </form>
        <div className="text-sm text-center mt-4 text-muted-foreground">
          New here? <Link to="/register" data-testid="link-register" className="text-candle-terracotta font-medium">Create an account</Link>
        </div>
      </div>
    </div>
  );
}

const Field = ({ label, v, onC, type = "text", tid }) => (
  <label className="block">
    <span className="text-sm font-medium">{label}</span>
    <input required type={type} value={v} onChange={(e) => onC(e.target.value)} data-testid={tid}
      className="mt-1 w-full px-3 py-2.5 rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--background))] text-sm focus:outline-none focus:ring-2 focus:ring-candle-terracotta/40" />
  </label>
);
